import { useGetWorkspaceQuery } from '@carboncopyco/data';
import { ArchiveIcon } from '@carboncopyco/icons';
import { LeftArrowIllustration } from '@carboncopyco/illustrations';
import { Breadcrumbs, ColorHex, TextPageHeader } from '@carboncopyco/ui';
import { useNavigate } from 'react-router-dom';
import { WorkspacePageBodyArchived } from './WorkspacePageBodyArchived';
import { useWorkspacePageProps } from './WorkspacePageContext';
import { WorkspacePageHeader } from './WorkspacePageHeader';

export const WorkspaceArchivedContent = () => {
  const { rootPath } = useWorkspacePageProps();
  const navigate = useNavigate();
  const { workspaceId, organizationId } = useWorkspacePageProps();

  const { data: workspace } = useGetWorkspaceQuery({
    organizationId: organizationId,
    id: workspaceId,
  });

  return (
    <>
      <WorkspacePageHeader>
        <div className="flex flex-col items-start gap-3">
          <Breadcrumbs
            links={[
              {
                onClick: () => {
                  navigate(rootPath);
                },
                label: workspace?.workspaceName,
              },
            ]}
            current="Archive"
          />
          <div className="flex items-center">
            <div
              className="hover:cursor-pointer pr-2"
              onClick={() => {
                navigate(rootPath);
              }}
            >
              <LeftArrowIllustration />
            </div>
            <div className="pr-4">
              <ArchiveIcon
                size={36}
                color={ColorHex.natural600}
              />
            </div>
            <TextPageHeader
              label="Archive"
              color="text-ds-natural-600"
            />
          </div>
        </div>
      </WorkspacePageHeader>
      <WorkspacePageBodyArchived />
    </>
  );
};
